import { useMemo } from 'react'

import debounce from 'lodash/debounce'
const useDebounce = (fn, delay = 200, deps, options) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debounced = useMemo(() => debounce(fn, delay, options), [...(deps || []), fn])
    return debounced
}
export default useDebounce
